module.exports = __webpack_public_path__ + "static/media/electronic.8a8e0f67.png";